module.exports = __webpack_public_path__ + "img/caipirinha.96dfac15.jpg";